export const NOTEBOOK_SHARELINK_ID = [
  '627ca3df-8f1d-475c-b63a-098dd7d650ca',  // Prod content for NB Welcome Center
  '86fb8863-cb85-4c98-b2f1-ec2bb9de11a6',
  'ddd6d9bd-fe7d-4bfe-b88e-9c0856a49504',
  '9e6409c6-7e85-41ad-be42-7faa4027c3e7',
  '91d98b60-a538-464d-ab97-48244439708c',
  '6cd954d9-fa50-4810-b3e3-63a036e0da01',   // Dev test content
  'c4591c72-fa66-4479-9cea-6f819232f32b'    // Preprod test content
]
